import router from '@/router'
import cmd from '@/common/Command'

const LinkModule = {
  namespaced: true,
  state: {
    rows: [],
    url: ""
  },
  mutations: {
    setRows (state, value) {
      state.rows = value 
    },
    setUrl (state, value) {
      state.url = value 
    }
  },
  actions: {
    //前ページ
    prevAction ({ commit, state, rootState }) {
      router.go(-1)
    },
    //
    search ({ commit, state, rootState }) {
      
      function callback(rows){
        var list = []
        $.each(rows, function(idx, row){
          if (row != "") {

            if (process.env.SUBJECT == "history") {
              list.push({"id": row[0], "title" : row[1], "subtitle" : row[2], "url": row[3]})

            } else {

              var logo = ""
              if (row[1] == "法") {
                logo = "static/images/links/tag-hou.svg"
              } else if (row[1] == "政治") {
                logo = "static/images/links/tag-seiji.svg"
              } else if (row[1] == "経済") {
                logo = "static/images/links/tag-keizai.svg"
              } else if (row[1] == "課題探求") {
                logo = "static/images/links/tag-kadai.svg"
              }

              list.push({"id": row[0], "logo": logo, "title" : row[2], "subtitle" : row[3], "url": row[4]})
            }
          }
        })
        commit('setRows', list)
      }
      cmd.getData("link", callback)
          
    },
    

  },
  getters: {    
    rows (state, getters, rootState) {
      return state.rows
    }
  }
}

export default LinkModule



// WEBPACK FOOTER //
// ./src/store/modules/LinkModule.js